import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/switching/compact/flex-mini-25g.png";
import type { Product } from "../../types";
import { productListSwitchingCompact } from "../product-list-groups/productListSwitchingCompact";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  ports,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const flexMini2_5G: Product = {
  id: "flexMini2_5G",
  productTitle: "Flex Mini 2.5G",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.Switching}/usw-flex-2-5g-5`,
  ],
  storePathParts: {
    productSlug: "usw-flex-2-5g-5",
    category: UniFiChildCategorySlug.SwitchingUtility,
  },
  description: "flexMini2_5G.description",
  image: { src: image, width: 200, height: 140 },
  productListGroup: productListSwitchingCompact,
  isNew: true,
  descriptionMaxWidth: 195,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '117.1 x 90 x 21.2 mm\n(4.6 x 3.5 x 0.8")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer3",
      },
    },
    {
      propertyId: "portCount",
      value: { type: "string", value: "5" },
    },
    {
      propertyId: ports.id,
      value: {
        type: "translation",
        value: "flexMini2_5G.ports",
      },
    },
    {
      propertyId: downlinkSpeed.id,
      value: {
        type: "translation",
        value: "flexMini2_5G.downlinkSpeed",
      },
    },
    {
      propertyId: uplinkSpeed.id,
      value: {
        type: "translation",
        value: "flexMini2_5G.uplinkSpeed",
      },
    },
    {
      propertyId: poeOutput.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "generalRedundancy",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "flexMini2_5G.powerMethod",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.desktop",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
